import { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useTheme } from '../../context/ThemeContext';
import useMediaQuery from '../../hooks/useMediaQuery';

const MODES = [
  { key: 'simple',     label: 'Simple'     },
  { key: 'analytical', label: 'Analytical' },
];

// A small segmented switch. On a phone, switching TO analytical first asks for
// confirmation (that mode is built for desktop).
const ModeToggle = () => {
  const { appMode, setMode } = useAuth();
  const { COLORS } = useTheme();
  const isNarrow = useMediaQuery('(max-width: 768px)');
  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleClick = (key) => {
    if (key === appMode) return;                             // no-op if already active
    if (key === 'analytical' && isNarrow) { setConfirmOpen(true); return; }
    setMode(key);
  };

  return (
    <>
      <div style={{ display: 'flex', gap: 2, background: COLORS.inputBg, padding: 3, borderRadius: 8, border: `1px solid ${COLORS.border}` }}>
        {MODES.map((m) => {
          const active = appMode === m.key;
          return (
            <button
              key={m.key}
              onClick={() => handleClick(m.key)}
              style={{
                padding: '4px 10px', borderRadius: 6, border: 'none', cursor: 'pointer',
                fontFamily: 'inherit', fontSize: 11, fontWeight: 700,
                background: active ? COLORS.accent : 'transparent',
                color: active ? '#fff' : COLORS.textMuted,
              }}
            >
              {m.label}
            </button>
          );
        })}
      </div>

      {confirmOpen && (
        <div
          onClick={() => setConfirmOpen(false)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{ background: COLORS.surface, border: `1px solid ${COLORS.border}`, borderRadius: 16, padding: '22px 20px', maxWidth: 340, width: '100%', fontFamily: "'DM Sans', sans-serif" }}
          >
            <div style={{ fontSize: 32, marginBottom: 10, textAlign: 'center' }}>🖥️</div>
            <h3 style={{ color: COLORS.text, fontSize: 17, fontWeight: 800, margin: '0 0 8px', textAlign: 'center' }}>Analytical is built for desktop</h3>
            <p style={{ color: COLORS.textMuted, fontSize: 13, lineHeight: 1.5, margin: '0 0 18px', textAlign: 'center' }}>
              This mode is designed for a larger screen and can be cramped on a phone. Do you still want to switch?
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <button
                onClick={() => { setMode('analytical'); setConfirmOpen(false); }}
                style={{ background: COLORS.accent, color: '#fff', border: 'none', borderRadius: 10, padding: '11px', fontSize: 14, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}
              >
                Switch anyway
              </button>
              <button
                onClick={() => setConfirmOpen(false)}
                style={{ background: 'transparent', color: COLORS.textMuted, border: `1px solid ${COLORS.border}`, borderRadius: 10, padding: '11px', fontSize: 14, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}
              >
                Stay on Simple
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ModeToggle;
